<div class="spinner"
     [style.flex-direction]="flexDirection">
  <ng-content></ng-content>

  <div *ngIf="isBusy"
       class="overlay"
       [style.position]="mode"
       [style.zIndex]="zIndex">
    <mat-spinner></mat-spinner>
  </div>
</div>
